import {
  FETCH_WELCOME_WIZARD_CAMPAIGN_REQUEST,
  FETCH_WELCOME_WIZARD_CAMPAIGN_SUCCESS,
  FETCH_WELCOME_WIZARD_CAMPAIGN_FAILURE,
  FETCH_APP_WELCOME_WIZARD_STATUS_REQUEST,
  FETCH_APP_WELCOME_WIZARD_STATUS_SUCCESS,
  FETCH_APP_WELCOME_WIZARD_STATUS_FAILURE,
  FETCH_APP_CAMPAIGN_WELCOME_WIZARD_STATUS_REQUEST,
  FETCH_APP_CAMPAIGN_WELCOME_WIZARD_STATUS_SUCCESS,
  FETCH_APP_CAMPAIGN_WELCOME_WIZARD_STATUS_FAILURE,
  FETCH_PATCH_ADD_APPS_WELCOME_WIZARD_CAMPAIGN_REQUEST,
  FETCH_PATCH_ADD_APPS_WELCOME_WIZARD_CAMPAIGN_SUCCESS,
  FETCH_PATCH_ADD_APPS_WELCOME_WIZARD_CAMPAIGN_FAILURE,
    FETCH_DELETE_APP_WELCOME_WIZARD_CAMPAIGN_REQUEST,
    FETCH_DELETE_APP_WELCOME_WIZARD_CAMPAIGN_SUCCESS,
    FETCH_DELETE_APP_WELCOME_WIZARD_CAMPAIGN_FAILURE,
    FETCH_DELETE_CAMPAIGN_NAME_WELCOME_WIZARD_REQUEST,
    FETCH_DELETE_CAMPAIGN_NAME_WELCOME_WIZARD_SUCCESS,
    FETCH_DELETE_CAMPAIGN_NAME_WELCOME_WIZARD_FAILURE
} from './WelcomeWizardTypes';

const intialState = {
  loading: false,
  campaignData:[],
  appsData:[],
CampaignNameCampaignData:  {},
  error: ''
};

const welcomeWizardReducer = (state = intialState, action) => {
  switch (action.type) {
    case FETCH_WELCOME_WIZARD_CAMPAIGN_REQUEST: 
    case FETCH_APP_WELCOME_WIZARD_STATUS_REQUEST:
    case FETCH_APP_CAMPAIGN_WELCOME_WIZARD_STATUS_REQUEST:
    case FETCH_PATCH_ADD_APPS_WELCOME_WIZARD_CAMPAIGN_REQUEST:
    case FETCH_DELETE_APP_WELCOME_WIZARD_CAMPAIGN_REQUEST:
    case FETCH_DELETE_CAMPAIGN_NAME_WELCOME_WIZARD_REQUEST:
        return {    
            ...state,
            loading: true
        };      
    case FETCH_WELCOME_WIZARD_CAMPAIGN_SUCCESS: 
        return {    
            ...state,
            loading: false,     
            campaignData: action.payload,
            error: ''
        };      
    case FETCH_WELCOME_WIZARD_CAMPAIGN_FAILURE:
        return {    
            ...state,
            loading: false,     
            campaignData: [],
            error: action.payload
        };
	case FETCH_APP_WELCOME_WIZARD_STATUS_SUCCESS:
	    return {
            ...state,
		loading: false,	
		appsData: action.payload,
		error: ''
	    };
	case FETCH_APP_WELCOME_WIZARD_STATUS_FAILURE:
	    return {
            ...state,
		loading: false,	
		appsData: [],
		error: action.payload
	    };
	case FETCH_APP_CAMPAIGN_WELCOME_WIZARD_STATUS_SUCCESS:
	    return {
            ...state,
		loading: false,	
		CampaignNameCampaignData:action.payload,
		error: ''
	    };
	case FETCH_APP_CAMPAIGN_WELCOME_WIZARD_STATUS_FAILURE:
	    return {
            ...state,
		loading: false,	
		CampaignNameCampaignData: {},
		error: action.payload
	    };
    case FETCH_PATCH_ADD_APPS_WELCOME_WIZARD_CAMPAIGN_SUCCESS:
    case FETCH_DELETE_APP_WELCOME_WIZARD_CAMPAIGN_SUCCESS:
    case FETCH_DELETE_CAMPAIGN_NAME_WELCOME_WIZARD_SUCCESS:
        return {
            ...state,
            loading: false,
            error: ''
        };
    case FETCH_PATCH_ADD_APPS_WELCOME_WIZARD_CAMPAIGN_FAILURE:
    case FETCH_DELETE_APP_WELCOME_WIZARD_CAMPAIGN_FAILURE:
    case FETCH_DELETE_CAMPAIGN_NAME_WELCOME_WIZARD_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.payload
        };  
    default:
        return state;
  }
};

export default welcomeWizardReducer;    